var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M35.7209 0H4.28651C3.14965 0 2.05936 0.454724 1.25549 1.26414C0.451613 2.07355 0 3.17135 0 4.31603L0 35.9669C0 37.1116 0.451613 38.2094 1.25549 39.0188C2.05936 39.8282 3.14965 40.283 4.28651 40.283H16.5432V26.5877H10.9172V20.1415H16.5432V15.2284C16.5432 9.64004 19.8474 6.55317 24.9082 6.55317C27.3318 6.55317 29.8662 6.98837 29.8662 6.98837V12.4733H27.0737C24.3223 12.4733 23.4642 14.1925 23.4642 15.9558V20.1415H29.6064L28.624 26.5877H23.4642V40.283H35.7209C36.8577 40.283 37.948 39.8282 38.7519 39.0188C39.5558 38.2094 40.0074 37.1116 40.0074 35.9669V4.31603C40.0074 3.17135 39.5558 2.07355 38.7519 1.26414C37.948 0.454724 36.8577 0 35.7209 0Z","fill":"#1D2738"}));
}

FacebookInline.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
